import React from "react";
import "./Banner2.css";
import { Jumbotron, Button, Row, Col } from "react-bootstrap";
const Banner2 = () => {
  return (
    <Jumbotron className="banner2 text-white d-flex justify-content-center align-items-center">
      <Row className="d-flex align-items-center justify-content-center">
        <Col className="text-center">
          <h2
            style={{ fontSize: "50px", fontWeight: "600", lineHeight: "1.2" }}
          >
            GET TRAINING TODAY
          </h2>
          <p className="w-75 mx-auto">
            Gimply dummy text of the printing and typesetting industry. Lorem
            Ipsum has been the industry’s standard.
          </p>
          <p>
            <button>
              Learn more
            </button>
          </p>
        </Col>
        <Col className="d-none d-md-block text-center align-self-end">
          <img
            className="img-fluid banner2img"
            src="https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2017/05/get-training.png"
            alt="banner"
          />
        </Col>
      </Row>
    </Jumbotron>
  );
};

export default Banner2;
